import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `${window.location.origin}${item.href}` : undefined,
    })),
  };

  return (
    <nav aria-label="面包屑导航" className="py-3">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <ol className="flex items-center flex-wrap text-sm text-foreground-500">
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            {index > 0 && (
              <i className="ri-arrow-right-s-line mx-1 text-foreground-400 flex items-center justify-center w-3 h-3" aria-hidden="true"></i>
            )}
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}